import { selector } from "recoil";

import { landingInitDataAtom } from "../atoms";

export const landingCompanyIdSelector = selector<number | undefined>({
  key: "landingCompanyIdSelector",
  get: ({ get }) => {
    const landingInitData = get(landingInitDataAtom);
    return landingInitData?.companyId;
  },
});

export const landingInitDataAtomLanguageSelector = selector<string | undefined>(
  {
    key: "landingProfileMetadataLanguageSelector",
    get: ({ get }) => {
      const initData = get(landingInitDataAtom);
      return initData?.language;
    },
  },
);
